import ServionWordmark from '@/components/icons/servion/servion-wordmark';
import { home } from '@/routes';
import { Link } from '@inertiajs/react';
import { type PropsWithChildren } from 'react';

interface AuthLayoutProps {
    title?: string;
    description?: string;
}

const pitchHeadline =
    'NFS-e com conformidade e integração para sua operação fiscal.';
const pitchSub =
    'Emita, gerencie e exporte com segurança — com integrações que se encaixam no seu fluxo.';
const brandFoot = '© Servion — para contadores e empresas prestadoras';

export default function AuthSplitLayout({
    children,
    title,
    description,
}: PropsWithChildren<AuthLayoutProps>) {
    return (
        <div className="auth">
            <aside className="auth__brand">
                <Link
                    href={home()}
                    className="inline-flex items-center"
                    aria-label="Servion"
                >
                    <ServionWordmark
                        width={160}
                        height={28}
                        primaryColor="#7edcb1"
                        textVariant="solid"
                        textColor="#ffffff"
                    />
                </Link>

                <div className="auth__brand-pitch">
                    <h2>{pitchHeadline}</h2>
                    <p>{pitchSub}</p>
                </div>

                <div className="auth__brand-foot">{brandFoot}</div>
            </aside>

            <div className="auth__form-wrap">
                <div className="auth__form">
                    {(title || description) && (
                        <div>
                            {title && (
                                <div className="auth__title">{title}</div>
                            )}
                            {description && (
                                <div className="auth__desc">{description}</div>
                            )}
                        </div>
                    )}
                    {children}
                </div>
            </div>
        </div>
    );
}
